import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiSendGenericSupportEmail(text: any, type: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/email/generic`, {
    text,
    type
  });
}

export function apiSendRequestSupportEmail(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/email/request`, data);
}

